/** Chip labels longer than this are drawn shortened, with the full text in a tooltip. */
export const DEFAULT_CHIP_LABEL_MAX_LENGTH = 28;

/**
 * Shortens a chip label to `maxLength`, marking the cut with an ellipsis.
 *
 * Shared by the components that draw these labels: app-membership-chips and
 * app-attribute-tag-chips. This is the only truncation those labels get, and
 * the chips' tooltips are gated on it, so the full value stays readable on
 * hover -- keep it that way rather than adding a second, width-based ellipsis
 * in CSS that the tooltip would not know about.
 */
export function truncateChipLabel(
  label: string,
  maxLength: number = DEFAULT_CHIP_LABEL_MAX_LENGTH,
): string {
  return label.length > maxLength
    ? `${label.slice(0, maxLength).trimEnd()}…`
    : label;
}
